var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReviewGood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FFF1DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8813 53.5H44.8735C45.4839 53.5 46.0922 53.4274 46.6854 53.2836V53.2836C50.1368 52.4473 52.5675 49.3574 52.5675 45.8061V37.705C52.5675 36.2222 51.3713 35.0172 49.8885 35.0062L40.5595 34.9375L42.9536 29.2794C43.5115 27.9607 42.5435 26.5 41.1117 26.5H40.0376C39.4392 26.5 38.8721 26.768 38.4922 27.2304L32.8813 34.0603M32.8813 53.5V34.0603M32.8813 53.5L28.9326 53.5001C28.1042 53.5001 27.4326 52.8285 27.4326 52.0001V35.5603C27.4326 34.7319 28.1042 34.0603 28.9326 34.0603L32.8813 34.0603",
    stroke: "#FF9C07",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewGood);
export default __webpack_public_path__ + "static/media/review_good.0718f710551e042646337b4fa68cdcf2.svg";
export { ForwardRef as ReactComponent };